import React from 'react';
import styled from 'styled-components';

import { StyledLink } from './common';
import { Folder } from '../types';

const ListItem = styled.li`
  background-color: #fff;
  border-radius: 54px;
  padding: 0.5em;
  margin-bottom: 0.5em;
  text-align: left;

  @media (max-width: 350px) {
    border-radius: 0;
    margin-left: -16px;
    margin-right: -16px;
  }
`;

const FolderPreview = styled(ListItem)`
  font-size: 1.2rem;
  line-height: 1.4em;
  display: flex;

  & img {
    vertical-align: middle;
    margin: auto 1em auto 0.5em;
  }

  @media (max-width: 450px) {
    font-size: 1.1rem;
    line-height: 24px;

    & img {
      border-radius: 0;
      width: 32px;
      height: 32px;
    }
  }

  &.private {
    opacity: 0.5;
    border: 1px dashed darkred;
  }
`;

const FolderTitle = styled.span`
  padding: 0.5em 0;
`;

const THUMBNAIL_SIZES = [
  { suffix: '', width: 108 },
  { suffix: '@2x', width: 216 },
  { suffix: '@3x', width: 324 },
  { suffix: '@4x', width: 432 },
];

const FolderInList = ({ folder }: { folder: Folder }) => {
  return (
    <StyledLink href={`/${folder.tab}/${folder.slug}`} key={folder.id}>
      <FolderPreview className={folder?.visibility || ''}>
        <img
          src={`https://pvapp-folder-images.b-cdn.net/thumbs/${folder.thumbnail || 'default'}.png`}
          srcSet={THUMBNAIL_SIZES.map(
            ({ suffix, width }) =>
              `https://pvapp-folder-images.b-cdn.net/thumbs/${folder.thumbnail || 'default'}${suffix}.png ${width}w`,
          ).join(', ')}
          sizes="(max-width: 450px) 32px, 54px"
          width={54}
          height={54}
          alt=""
        />
        <FolderTitle>{folder.title}</FolderTitle>
      </FolderPreview>
    </StyledLink>
  );
};

export default FolderInList;
